import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';

export interface TransactionStatus {
	startAt: string;
}

@Injectable({
	providedIn: 'root'
})
export class NgxBraintreeService {

	constructor (private http: HttpClient) { }

	public getPaymentTransactionStatus (groupId: number): Observable<TransactionStatus> {
		return this.http.get<TransactionStatus>(`${clientSettings.GoReactV2API}/groups/${groupId}/payment/transaction/status`);
	}
}
